'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _InputConstants = require('./InputConstants');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TYPES = ['text', 'email', 'number', 'password', 'search'];

exports.default = _react2.default.createClass({
  displayName: 'UITextInput',

  propTypes: {
    className: _react.PropTypes.string,
    defaultValue: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    onChange: _react.PropTypes.func,
    placeholder: (0, _createLazyPropType2.default)(_react.PropTypes.string),
    readOnly: _react.PropTypes.bool,
    styled: _react.PropTypes.bool.isRequired,
    type: _react.PropTypes.oneOf(TYPES),
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      styled: true,
      type: 'text'
    };
  },
  focus: function focus() {
    if (this._inputRef) {
      this._inputRef.focus();
    }
  },
  select: function select() {
    if (this._inputRef) {
      this._inputRef.select();
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        error = _props.error,
        placeholder = _props.placeholder,
        styled = _props.styled,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['className', 'error', 'placeholder', 'styled', 'use']);

    var computedClassName = (0, _reactUtils.classNames)('form-control private-form__control', className, {
      'private-form__control--unstyled uiTextInputUnstyled': !styled,
      'private-form__control--error': error
    }, _InputConstants.USE_CLASSES[use]);

    return _react2.default.createElement('input', _extends({}, rest, {
      className: computedClassName,
      placeholder: (0, _lazyEval2.default)(placeholder),
      ref: this.inputRefCallback
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/input/UITextInput.js
// module id = 248
// module chunks = 0 1